import React from "react";
import {
  Stack,
  Typography,
  styled,
  IconButton,
  Button,
  TextField,
} from "@mui/material";
const Card = styled(Stack)(({ theme }: any) => ({
  backgroundColor: theme.palette.common.white,
  borderBottom: `4px solid ${theme.palette.common.green}`,
  boxShadow: "5px 5px 20px rgba(0, 0, 0, 0.25)",
  backdropFilter: `blur(3px)`,
  "& .badge": {
    backgroundColor: theme.palette.common.green,
    color: theme.palette.common.white,
    borderRadius: "15px",
    padding: "4px 5px",
    minWidth: "30px",
    maxWidth: "45px",
    height: "30px",
  },
  "& .shadow-button": {
    color: theme.palette.common.black,
    background: theme.palette.common.white,
    borderRadius: "15px",
    boxShadow: `0px 0.866667px 3.46667px rgba(0, 0, 0, 0.25)`,
  },
  "& .button": {
    height: "40px",
    padding: "5px 10px",
    fontSize: "12px",
    fontWeight: 400,
  },
  "& .icon-button": {
    background: "none",
    width: "fit-content",
    height: "fit-content",
    padding: 0,
  },
}));

interface EventDetailCardInterface {
  eventName: string;
  days?: number;
}

const EventDetailCard = ({
  eventName,
  days,
}: EventDetailCardInterface) => {
  return (
    <Card
      justifyContent="space-between"
      padding="25px 15px"
      minWidth="310px"
      width="310px"
      height="352px"
    >
      <Typography variant="h3">{eventName}</Typography>
      <Stack spacing={2}>
        <Typography
          color={(theme: any) => theme.palette.common.grey}
          variant="h4"
          fontWeight={400}
        >
          Catagories
        </Typography>

        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
        >
          <TextField
            placeholder="Catagories"
            style={{ border: 0, padding: 0 }}
            variant="outlined"
            fullWidth
          />
          <IconButton
            disableRipple
            sx={{
              backgroundColor: "#00000066",
              borderRadius: "13px",
              height: "45px",
              width: "44px",
            }}
          >
            <i className="fas fa-ellipsis-h font-white"></i>
          </IconButton>
        </Stack>
      </Stack>
      <Stack direction="row" alignItems="center" justifyItems="start">
        <Stack
          className="badge"
          mr={1}
          alignItems="center"
          justifyContent="center"
        >
          {days}
        </Stack>
        <Typography
          color={(theme: any) => theme.palette.common.grey}
          variant="h5"
          fontWeight={400}
        >
          day(s) left until start
        </Typography>
      </Stack>

      <Stack
        spacing={1}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <IconButton
          color="secondary"
          className="button shadow-button"
          sx={{ height: "50px" }}
        >
          <i className="far fa-share-alt"></i>
        </IconButton>

        <Button
          className="button shadow-button"
          startIcon={<i className="far fa-star font-black"></i>}
          variant="text"
          color="secondary"
        >
          Interested
        </Button>

        <IconButton className="icon-button">
          <i className="far fa-upload font-black"></i>
        </IconButton>
        <IconButton className="icon-button">
          <i className="fal fa-calendar font-black"></i>
        </IconButton>
        <Button color="primary" variant="contained" className="button">
          Details
        </Button>
      </Stack>
    </Card>
  );
};
export default EventDetailCard;
